import React from 'react';

const PlanPrice = () =>
  <div>
    <div className="plan-price">
      <span className="money-sign"> $</span>
      <span className="price-amount" data-price-tag=""> 0</span>
      <span className="price-time" data-time-period=""> /mo</span>
    </div>
    <span className="price-alt-text">Get in touch</span>
  </div>;

export default PlanPrice;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/planBox/PlanPrice.js